const Backbone = require("backbone");
var ApiConfig = require("_lib/data/ApiConfig.js");

var Subscription = Backbone.Model.extend({
  urlRoot: ApiConfig.getPrefix() + "/subscription",
});

module.exports = Subscription;
